export const baseImageStyle = {
  width: "100%",
  height: "100%",
  resizeMode: "cover",
} as const;
